import { render, staticRenderFns } from "./ProgramaPage.vue?vue&type=template&id=170ab406&scoped=true&"
import script from "./ProgramaPage.js?vue&type=script&lang=js&"
export * from "./ProgramaPage.js?vue&type=script&lang=js&"
import style0 from "./ProgramaPage.vue?vue&type=style&index=0&id=170ab406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ab406",
  null
  
)

export default component.exports